import store from '@/store'
export default [
  {
    path: '/employees',
    name: 'employee',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/index.vue')
  },
  {
    path: '/employees/create',
    name: 'employee-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/create.vue')
  },
  {
    path: '/employees/:id',
    name: 'employee-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('employee/find', to.params.id)
      next()
    }
  },
  {
    path: '/employees/:id/show',
    name: 'employee-show',
    meta: { requiresAuth: true },
    component: () => import('@/pages/employee/show.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('employee/find', to.params.id)
      next()
    }
  }
]
